export const homeFr = {
    announcementsTitle: 'Annonces',
}
